import { ITripServiceDto } from '../../service-type-dto.interface';

export interface ICreateTripCheckpointInput {
    type?: string;
    locationId: string;
    isStopover?: boolean;
    duration?: string;
    plannedAt?: string;
    accountId?: string;
    orders?: {
        code?: string;
        label?: string;
        operation?: string;
        qtn?: string;
        orderItems?: { product: { name: string; code: string }; quantity?: number; weight?: number }[];
        orderMeasures?: { type: string; value: number }[];
    }[];
}

/**
 * Contract for the BFF's `CreateTripInput` GraphQL input, which `CreateTripInput` implements.
 * stork-app cannot import that class across the nx app boundary, so this is what types the
 * `createTrip` mutation on the frontend — the same arrangement as {@link IUpdateTripInput}.
 */
export interface ICreateTripInput {
    tripDefinition: string;
    code: string;
    scheduledStart: string;
    vehicleId?: string | null;
    driverId?: string | null;
    companionId?: string | null;
    carrierId?: string | null;
    semitrailerIds?: string[] | null;
    accounts?: string[];
    tags?: string[];
    rateId?: string | null;
    services?: ITripServiceDto[] | null;
    checkpoints: ICreateTripCheckpointInput[];
}
